import {
  Component,
  HostListener,
  Inject,
  OnInit,
  Optional,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { AppComponent } from 'src/app/app.component';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ForgetPasswordComponent } from '../forget-password/forget-password.component';
import { RegisterModalComponent } from '../register-modal/register-modal/register-modal.component';
@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css'],
})
export class LoginPageComponent implements OnInit {
  loginForm: FormGroup;
  private loginApi = environment.url + environment.login;

  /**
   * Constructs a new instance of the LoginPageComponent class.
   * @param router The Angular router for navigating between routes.
   * @param fb The Angular form builder for creating form controls.
   * @param data Optional dialog data passed to the component when it is opened as a dialog.
   * @param dialog The Angular material dialog service for opening dialogs.
   * @param makeapi The API service for making API calls to the backend.
   * @param getdata The value service for getting global values.
   * @param notify The notification service for displaying notifications.
   * @param appCom The app component for accessing the app component's methods.
   */
  constructor(
    private router: Router,
    private fb: FormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    private appCom: AppComponent
  ) {
    /**
     * Creates a form group with the required fields for the login form.
     */
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }
  get add() {
    return this.loginForm.controls;
  }
  /**
   * Angular lifecycle hook that is called after the component's view has been fully initialized.
   * This method sets the visibility state, logs out if the user is already logged in,
   * and disables the back button functionality.
   */
  ngOnInit(): void {
    // Set the visibility state to true
    this.getdata.isVisibleSource.next(true);

    // Log out the user if they are already logged in
    this.logoutIfLoggedIn();

    // Disable the back button functionality
    this.disableBackButton();
  }
  /**
   * Logs out the user if they are currently logged in by checking the presence of a JWT token in session storage.
   * If the user is logged in, it logs them out and reloads the page.
   */
  logoutIfLoggedIn(): void {
    // Check if the user is logged in by verifying if the JWT token exists in session storage
    const isLoggedIn = sessionStorage.getItem('jwttoken') !== null;

    // If the user is logged in
    if (isLoggedIn) {
      // Call the logout method to clear session and navigate to login page
      this.logout();
      // Reload the page to reflect changes
      window.location.reload();
    }
  }
  /**
   * Disables the back button functionality by pushing a new state to the history stack.
   * This prevents the user from navigating back to the previous page using the back button.
   */
  disableBackButton(): void {
    // Push a new state to the history stack with the current URL
    window.history.pushState(null, '', window.location.href);
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event: Event): void {
    window.history.pushState(null, '', window.location.href);
  }
  /**
   * Logs the user out by clearing the session storage and navigating to the login page.
   */
  logout() {
    // Clear the session storage
    sessionStorage.clear();
    // Navigate to the login page
    this.router.navigateByUrl('/login');
  }
  conversionDecryptOutput: any;
  /**
   * Encrypts the given plain text using the AES encryption algorithm
   * and logs in the user using the encrypted password.
   */
  loginAdmin() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
      return;
    } else {
      let getform = this.loginForm.value;
      this.convertTextEnc(getform.password);
      let req = {
        username: getform.username,
        password: this.conversionDecryptOutput,
      };
      this.getdata.amizhthLoader('show');
      this.makeapi.method(this.loginApi, req, 'login').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          // Save the necessary data in the session storage
          sessionStorage.setItem('incubName', data.incubatorName);
          sessionStorage.setItem('username', data.username);
          sessionStorage.setItem('jwttoken', data.token);
          sessionStorage.setItem('userId', data.userId);
          sessionStorage.setItem('role', data.role);
          sessionStorage.setItem('privileges', JSON.stringify(data.privileges));
          sessionStorage.setItem('profileReg', data.profileRegistered);
          sessionStorage.setItem(
            'profileRegCorporate',
            data.csrProfileRegistered
          );

          // Navigate to the appropriate page based on the user's role
          if (data.role == 'Corporate') {
            this.router.navigateByUrl('/corporate-profile');
          }
          if (data.role == 'Incubator') {
            if (data.profileUptodate == 1) {
              if (data.profileRegistered == 'No') {
                this.router.navigateByUrl('/profile');
              } else {
                this.router.navigate(['uploadcsrsdoc', {}]);
              }
            } else {
              if (data.profileRegistered == 'No') {
                this.router.navigateByUrl('/profile');
              } else {
                this.appCom.updateProfile();
              }
            }
          } else if (data.role == 'Preincubator') {
            this.router.navigate(['admin', 'pre-incubation', {}]);
          } else if (data.role == 'CoE') {
            this.router.navigate(['admin', 'coe', {}]);
          } else if (data.role == 'Corporate') {
            if (data.profileUptodate == 1) {
              if (data.profileRegistered == 'No') {
                this.router.navigateByUrl('/corporate-profile');
              } else {
                this.router.navigate(['csrsavailproject', {}]);
              }
            } else {
              if (data.profileRegistered == 'No') {
                this.router.navigateByUrl('/corporate-profile');
              } else {
                this.appCom.updateProfile();
              }
            }
          } else if (data.role == 'Admin') {
            this.router.navigate(['incubator-list', {}]);
          }
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  /**
   * Resets the login form and navigates to the home page when the cancel button is clicked.
   */
  cancelReg() {
    // Reset the login form
    this.loginForm.reset();
    // Navigate to the home page
    this.router.navigateByUrl('/home');
  }
  public showPassword: boolean = true;
  /**
   * Toggles the visibility of the password input field.
   * Switches between 'text' and 'password' input types.
   */
  public togglePasswordVisibility(): void {
    // Toggle the boolean value of showPassword
    this.showPassword = !this.showPassword;
  }

  /**
   * Encrypts the given plain text using the AES encryption algorithm.
   * @param plainText The text to be encrypted.
   */
  convertTextEnc(plainText: string): void {
    const iv = '297A1646BC32E036CF3C4DE1B1926A71';
    const salt =
      '32E036CF3C4DE1B192297A1646BC6A71297A164DE1B1926A716BC32E036CF3C4';
    const keySize = 128;
    const iterationCount = 1024;
    const passPhrase = 'varuvaaiencryption';

    // Define the AesUtil class which contains the generateKey and encrypt methods.
    class AesUtil {
      keySize: number;
      iterationCount: number;

      constructor(keySize: number, iterationCount: number) {
        this.keySize = keySize / 32;
        this.iterationCount = iterationCount;
      }

      /**
       * Generates a key from the given salt and passPhrase using the PBKDF2 algorithm.
       * @param salt The salt value.
       * @param passPhrase The passPhrase.
       * @returns The generated key.
       */
      generateKey(salt: string, passPhrase: string): CryptoJS.LibWordArray {
        const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
          keySize: this.keySize,
          iterations: this.iterationCount,
        });
        return key;
      }

      /**
       * Encrypts the given plain text using the AES encryption algorithm.
       * @param salt The salt value.
       * @param iv The initialization vector.
       * @param passPhrase The passPhrase.
       * @param plainText The text to be encrypted.
       * @returns The encrypted text.
       */
      encrypt(
        salt: string,
        iv: string,
        passPhrase: string,
        plainText: string
      ): string {
        const key = this.generateKey(salt, passPhrase);
        const encrypted = CryptoJS.AES.encrypt(plainText, key, {
          iv: CryptoJS.enc.Hex.parse(iv),
        });
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
      }
    }

    // Create an instance of the AesUtil class and call the encrypt method.
    const aesUtil = new AesUtil(keySize, iterationCount);
    this.conversionDecryptOutput = aesUtil.encrypt(
      salt,
      iv,
      passPhrase,
      plainText
    );
  }
  /**
   * Redirects the user to the registration page.
   */
  Register() {
    this.router.navigateByUrl('/register');
  }
  /**
   * Opens the forget password dialog and handles actions after it closes.
   */
  forget() {
    // Open the ForgetPasswordComponent dialog with specified width.
    const dialogRef = this.dialog.open(ForgetPasswordComponent, {
      width: '390px',
    });

    // After the dialog is closed, execute the following actions.
    dialogRef.afterClosed().subscribe((result) => {
      // Notify that the visibility source has been updated.
      this.getdata.isVisibleSource.next(true);
    });
  }
  /**
   * Opens the registration modal.
   */
  openModal() {
    const dialogRef = this.dialog.open(RegisterModalComponent, {
      // The width and height of the modal are set to 1000px and 330px respectively.
      width: '1000px',
      height: '330px',
    });
    // After the modal is closed, the code inside the subscribe method is executed.
    dialogRef.afterClosed().subscribe((result) => {});
  }
}
